export default __webpack_public_path__ + "assets/icons/close.7f424c56.svg";